export const ALERT_CARD_TEXTS = {
    TITLE: "Major update alert!",
    SUBTEXT: "Swiggy HDFC Bank Credit Card cashback will now credit directly in the statement.",
};

export const ALERT_CARD_ICON = {
    SRC: "portal/m/sm/Offers.png",
    WIDTH: 48,
    HEIGHT: 48,
};
